import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterPermissions',
})
export class FilterPermissionsPipe implements PipeTransform {
  transform(permissions: object | null | undefined): string[] {
    if (!permissions) {
      return [];
    }
    return Object.entries(permissions)
      .filter(([, granted]) => granted === true)
      .map(([key]) => this.formatKey(key));
  }

  private formatKey(key: string): string {
    // Replace underscores with spaces
    const withSpaces = key.replace(/_/g, ' ');
    // Capitalize each word
    return withSpaces.replace(/\b\w/g, c => c.toUpperCase());
  }
}
